
import { combineReducers } from "redux";
import AuthReducer from "./AuthReducer";
import GeneralReducer from "./GeneralReducer";
import PagesReducer from "./PagesReducer";
import DashboardReducer from "./DashboardReducer";
import YardsaleReducer from "./YardsaleReducer";
import PaymentsReducer from "./PaymentsReducer";

// const eventPlanPersistConfig = {
//   key: "root",
//   storage: storage,
//   whitelist: [
//     "EventPlanningReducer",
//     "GuestReducer",
//     "EventReducer",
//     "AuthReducer",
//   ],
// };

const AppReducers = combineReducers({
  GeneralReducer,
  AuthReducer,
  PagesReducer,
  DashboardReducer,
  YardsaleReducer,
  PaymentsReducer
});

const Reducer = (state, action) => {
  if (action.type === "IsLogout") {
    return AppReducers(undefined, action);
  }
  return AppReducers(state, action);
};
// const persistedReducer = persistReducer(eventPlanPersistConfig, Reducer);

export default Reducer;
